<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.167 18.958H5.83366C2.96699 18.958 1.04199 17.033 1.04199 14.1663V9.99967C1.04199 7.43301 2.62533 5.57468 5.08366 5.26635C5.31699 5.23301 5.57533 5.20801 5.83366 5.20801H14.167C14.367 5.20801 14.6253 5.21634 14.892 5.25801C17.3503 5.54134 18.9587 7.40801 18.9587 9.99967V14.1663C18.9587 17.033 17.0337 18.958 14.167 18.958ZM5.83366 6.45801C5.63366 6.45801 5.44199 6.47466 5.25033 6.49966C3.41699 6.733 2.29199 8.06634 2.29199 9.99967V14.1663C2.29199 16.3163 3.68366 17.708 5.83366 17.708H14.167C16.317 17.708 17.7087 16.3163 17.7087 14.1663V9.99967C17.7087 8.04967 16.567 6.70801 14.717 6.49135C14.517 6.45801 14.342 6.45801 14.167 6.45801H5.83366Z"
      :fill="color"
    />
    <path
      d="M5.15805 6.50853C4.95805 6.50853 4.77471 6.41687 4.64971 6.2502C4.50805 6.05854 4.49138 5.80854 4.59971 5.6002C4.74138 5.31687 4.94138 5.04187 5.19971 4.79187L7.90805 2.0752C9.29138 0.700195 11.5414 0.700195 12.9247 2.0752L14.383 3.55021C14.9997 4.15854 15.3747 4.97521 15.4164 5.84188C15.4247 6.03355 15.3497 6.21686 15.208 6.34186C15.0664 6.46686 14.8747 6.52521 14.6914 6.49188C14.5247 6.46688 14.3497 6.45854 14.1664 6.45854H5.83305C5.63305 6.45854 5.44138 6.47519 5.24971 6.50019C5.22471 6.50853 5.19138 6.50853 5.15805 6.50853ZM6.54971 5.20854H14.0164C13.908 4.9252 13.733 4.66688 13.4997 4.43354L12.033 2.95021C11.1414 2.06688 9.68305 2.06688 8.78305 2.95021L6.54971 5.20854Z"
      :fill="color"
    />
    <path
      d="M18.3337 14.3753H15.8337C14.567 14.3753 13.542 13.3503 13.542 12.0837C13.542 10.817 14.567 9.79199 15.8337 9.79199H18.3337C18.6753 9.79199 18.9587 10.0753 18.9587 10.417C18.9587 10.7587 18.6753 11.042 18.3337 11.042H15.8337C15.2587 11.042 14.792 11.5087 14.792 12.0837C14.792 12.6587 15.2587 13.1253 15.8337 13.1253H18.3337C18.6753 13.1253 18.9587 13.4087 18.9587 13.7503C18.9587 14.092 18.6753 14.3753 18.3337 14.3753Z"
      :fill="color"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      default: "#292626",
      type: String,
    },
  },
};
</script>
